{
  "grid": {
    "reorderBlocked": {
      "sort": "Clear the sort to reorder rows",
      "search": "Clear the search to reorder rows"
    },
    "empty": {
      "noColumns": "This table has no columns.",
      "noColumnsYet": "This table has no columns yet.",
      "noRows": "No rows.",
      "noRowsYet": "No rows yet.",
      "noMatch": "No row matches the current search or filters."
    },
    "addColumn": "Add a column",
    "selectAll": "Select all rows",
    "clearSelection": "Clear the selection",
    "newRow": "New row",
    "newRowClearsView": "New row — clears the current view",
    "dragToReorder": "Drag to reorder",
    "selectRow": "Select row",
    "openRow": "Open row"
  },
  "toolbar": {
    "searchPlaceholder": "Search…",
    "clearSearch": "Clear search",
    "rowHeight": "Row height",
    "filteredCount": "{{visible}} of {{total}}"
  },
  "rowCount": {
    "exact_one": "{{count}} row",
    "exact_other": "{{count}} rows",
    "partial": "{{count}}+ rows"
  },
  "rowHeights": {
    "short": "Short",
    "medium": "Medium",
    "tall": "Tall",
    "full": "Full"
  },
  "columnMenu": {
    "description": "Description",
    "descriptionPlaceholder": "What this column holds. Shown to Nolë and in the record.",
    "columnType": "Column type",
    "clearsCells_one": "Clears {{count}} cell",
    "clearsCells_other": "Clears {{count}} cells",
    "namePlaceholder": "Column name",
    "optionsAndSettings": "Options & settings",
    "sortAsc": "Sort A → Z",
    "sortDesc": "Sort Z → A",
    "clearSort": "Clear sort",
    "deleteColumn": "Delete column"
  },
  "fieldTypes": {
    "text": "Text",
    "rich_text": "Long text",
    "number": "Number",
    "checkbox": "Checkbox",
    "select": "Select",
    "multi_select": "Multi-select",
    "status": "Status",
    "date": "Date",
    "url": "URL",
    "email": "Email",
    "phone": "Phone",
    "file": "Files",
    "node": "Node",
    "relation": "Relation",
    "created_time": "Created time",
    "updated_time": "Last edited time"
  },
  "filters": {
    "button": "Filter",
    "empty": "No filters yet.",
    "where": "Where",
    "and": "And",
    "or": "Or",
    "deletedColumn": "Deleted column",
    "group_one": "A group of {{count}} condition",
    "group_other": "A group of {{count}} conditions",
    "remove": "Remove filter",
    "add": "Add filter",
    "clearAll": "Clear all",
    "optionPlaceholder": "Option",
    "dayPlaceholder": "2026-10-23, today…",
    "valuePlaceholder": "Value"
  },
  "operators": {
    "is_empty": "is empty",
    "is_not_empty": "is not empty",
    "eq": "is",
    "neq": "is not",
    "contains": "contains",
    "not_contains": "does not contain",
    "starts_with": "starts with",
    "ends_with": "ends with",
    "gt": ">",
    "gte": "≥",
    "lt": "<",
    "lte": "≤",
    "is_any_of": "is any of",
    "is_none_of": "is none of",
    "has_all_of": "has all of",
    "before": "is before",
    "after": "is after",
    "on_or_before": "is on or before",
    "on_or_after": "is on or after",
    "is_checked": "is checked",
    "is_unchecked": "is unchecked",
    "is_done": "is done",
    "is_not_done": "is not done"
  },
  "summaries": {
    "calculate": "Calculate",
    "count": "Count all",
    "count_empty": "Empty",
    "count_not_empty": "Filled",
    "count_unique": "Unique",
    "percent_empty": "Percent empty",
    "percent_not_empty": "Percent filled",
    "sum": "Sum",
    "average": "Average",
    "median": "Median",
    "min": "Min",
    "max": "Max",
    "range": "Range",
    "count_checked": "Checked",
    "count_unchecked": "Unchecked",
    "percent_checked": "Percent checked",
    "percent_unchecked": "Percent unchecked",
    "earliest": "Earliest",
    "latest": "Latest"
  },
  "bulk": {
    "toolbarLabel": "Selected rows",
    "selected_one": "{{count}} row selected",
    "selected_other": "{{count}} rows selected",
    "editField": "Edit a field",
    "dialogTitle_one": "Edit {{count}} row",
    "dialogTitle_other": "Edit {{count}} rows",
    "dialogDescription": "The value replaces the current one in each selected row. Left empty, it clears it.",
    "chooseField": "Choose a field",
    "applyTo_one": "Apply to {{count}} row",
    "applyTo_other": "Apply to {{count}} rows"
  },
  "record": {
    "title": "Row {{index}} <muted>of {{total}}</muted>",
    "description": "Every field of this row, at full width.",
    "previous": "Previous row",
    "next": "Next row",
    "deleteRow": "Delete row"
  },
  "import": {
    "emptyFile": "This CSV file is empty or has no header row.",
    "readError": "Could not read the file",
    "title": "Import CSV",
    "pickDescription": "Pick a CSV file to get started.",
    "mapDescription": "Check how the CSV columns map onto this table.",
    "changeFile": "Change file",
    "confirm": "Import",
    "confirmWithCount_one": "Import ({{count}} line)",
    "confirmWithCount_other": "Import ({{count}} lines)",
    "dropzone": "Drop a CSV file here, or click to browse.",
    "preview_one": "Preview (first {{count}} line)",
    "preview_other": "Preview (first {{count}} lines)",
    "emptyHeader": "(empty)",
    "mapping": "Column mapping",
    "csvColumn": "CSV column",
    "target": "Target",
    "type": "Type",
    "unnamedColumn": "(column {{index}})",
    "newColumn": "+ New column",
    "skip": "Skip",
    "mode": "Import mode",
    "append": "Append to existing rows",
    "replace": "Replace the table"
  },
  "fieldSettings": {
    "placeholder": "Placeholder",
    "showAs": "Show as",
    "display": "Display",
    "auto": "Auto",
    "text": {
      "maxLength": "Maximum length",
      "wrap": "Wrap in table",
      "wrapHint": "Show the whole text instead of one line"
    },
    "checkbox": {
      "toggle": "Toggle",
      "label": "Label",
      "labelHint": "Shown next to the box"
    },
    "number": {
      "formatGroup": "Format",
      "format": "Format",
      "percent": "Percent",
      "currency": "Currency",
      "currencyHint": "ISO code: EUR, USD, GBP…",
      "currencyDisplay": "Show currency as",
      "currencySymbol": "Symbol (€)",
      "currencyCode": "Code (EUR)",
      "currencyName": "Name (euros)",
      "currencyPosition": "Currency position",
      "automatic": "Automatic",
      "before": "Before",
      "after": "After",
      "unit": "Unit",
      "unitHint": "kg, h, km…",
      "unitPosition": "Unit position",
      "decimals": "Decimals",
      "thousandsSeparator": "Thousands separator",
      "abbreviate": "Abbreviate",
      "abbreviateHint": "1.2k, 3.4M",
      "range": "Range",
      "minimum": "Minimum",
      "maximum": "Maximum",
      "bar": "Bar",
      "ring": "Ring",
      "slider": "Slider",
      "color": "Color",
      "showValue": "Show the number",
      "step": "Step"
    },
    "choice": {
      "options": "Options",
      "behavior": "Behavior",
      "sort": "Sort options",
      "manual": "Manually",
      "alphabetical": "Alphabetically",
      "allowCreate": "Create options while typing",
      "pill": "Colored pill"
    },
    "status": {
      "statuses": "Statuses",
      "groupName": "Group name",
      "add": "Add a status",
      "groups": {
        "todo": "To do",
        "in_progress": "In progress",
        "done": "Done"
      }
    },
    "url": {
      "full": "Full address",
      "domain": "Domain",
      "title": "Page title"
    },
    "phone": {
      "defaultCountry": "Default country",
      "defaultCountryHint": "For numbers typed without +",
      "country": "{{country}} ({{dialCode}})"
    },
    "date": {
      "relative": "Relative (in 3 days)",
      "dateFormat": "Date format",
      "shortExample": "23/10/2026",
      "mediumExample": "23 Oct 2026",
      "longExample": "Friday 23 October 2026",
      "timeFormat": "Time format",
      "value": "Value",
      "includeTime": "Include time",
      "endDate": "End date",
      "endDateHint": "A range: from… to…"
    },
    "file": {
      "accepted": "Accepted files",
      "acceptedHint": "None checked: any file",
      "categories": {
        "image": "Images",
        "pdf": "PDF",
        "audio": "Audio",
        "video": "Video",
        "other": "Other files"
      },
      "multiple": "Several files",
      "maxSize": "Maximum size (MB)",
      "thumbnails": "Thumbnails",
      "list": "File names",
      "cover": "Cover image"
    },
    "node": {
      "any": "Any node",
      "type": "Node type",
      "multiple": "Several nodes"
    },
    "choose": "Choose…",
    "relation": {
      "untitledDatabase": "Untitled database",
      "unavailableDatabase": "Unavailable database",
      "database": "Database",
      "multiple": "Several rows",
      "twoWay": "Two-way",
      "twoWayOnNamed": "{{database}} shows the rows that link to it.",
      "twoWayOn": "The database shows the rows that link to it.",
      "twoWayOffNamed": "A column of {{database}} that links back.",
      "twoWayOff": "A column of the database that links back."
    },
    "richText": {
      "formatting": "Formatting",
      "formattingHint": "Headings, lists, bold… Off: plain text",
      "maxCellLines": "Lines in table"
    },
    "options": {
      "color": "Option color",
      "name": "Option name",
      "reorder": "Reorder",
      "delete": "Delete option",
      "descriptionPlaceholder": "Add a description for Nolë…",
      "description": "Option description",
      "add": "Add an option"
    }
  },
  "fieldEditors": {
    "emailPlaceholder": "name@example.com",
    "date": {
      "rangePlaceholder": "Tomorrow → next friday",
      "placeholder": "Tomorrow, 23/10, next monday 2pm…",
      "startTime": "Start time",
      "endTime": "End time"
    },
    "file": {
      "uploadFailed": "Upload failed.",
      "remove": "Remove {{name}}",
      "upload": "Upload a file",
      "replace": "Replace the file"
    },
    "node": {
      "unavailable": "Unavailable node"
    },
    "relation": {
      "linked": "Linked",
      "rows": "Rows",
      "noDatabase": "Choose the database this relation links to, in the column settings."
    },
    "options": {
      "searchOrCreate": "Search or create an option",
      "search": "Search an option",
      "create": "Create <pill></pill>",
      "none": "No option"
    },
    "empty": "Empty",
    "required": "required"
  },
  "layout": {
    "emptyText": "Empty text",
    "unknownField": "Unknown field"
  },
  "inlineEdit": {
    "placeholder": "Click to edit…"
  }
}
